import React, { useEffect, useState,useRef  } from "react";
import { Link } from "react-router-dom";

import CountUp from "react-countup";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";
import AOS from "aos";
import "aos/dist/aos.css";
// import type { Dayjs } from "dayjs";
// import dayjs from "dayjs";
// import { TimePicker } from "antd";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { all_routes } from "../../router/all_routes";

import Footer from "../../common/footer";
import Header from "../../common/header";
import BASE_URL from '../../../config';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { useAuth } from '../../../core/context/AuthContext';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../core/services/axiosInstance';
import 'react-toastify/dist/ReactToastify.css';
import SearchSection from "../../common/search";
import { Helmet } from 'react-helmet';

import { useLanguage } from "../../../core/context/LanguageContext";

const HomeOne = () => {
  const routes = all_routes;
  const { translations } = useLanguage();
  

  const [selectedItems, setSelectedItems] = useState(Array(10).fill(false));


  const { isAuthenticated } = useAuth(); // Access authentication status
  const navigate = useNavigate(); // For programmatic navigation





  const [cars, setCars] = useState([]);
  const [wishlistCars, setWishlistCars] = useState([]);

  const [wishlist, setWishlist] = useState([]);
  console.log(wishlistCars);

  const [isSticky, setIsSticky] = useState(false); // État pour fixer ou relâcher la barre
  const searchBarRef = useRef(null); // Référence pour la barre de recherche
  const initialOffset = useRef(0); // Stocke la position initiale

    
const [isMobile, setIsMobile] = useState(false);

// Fonction pour détecter la taille de l'écran
useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768); // Écran considéré comme "petit" si < 768px
  };

  handleResize();
  window.addEventListener('resize', handleResize);

  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);


  useEffect(() => {
    // Définit la position initiale après le rendu
    const handleResize = () => {
      if (searchBarRef.current) {
        initialOffset.current = searchBarRef.current.offsetTop;
      }
    };
    handleResize();

    // Ajouter un écouteur pour redimensionnement
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= initialOffset.current) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  // const onChange = (time: Dayjs, timeString: string) => {
  //   console.log(time, timeString);
  // };
  const handleItemClick = (index: number) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = [...prevSelectedItems];
      updatedSelectedItems[index] = !updatedSelectedItems[index];
      return updatedSelectedItems;
    });
  };
// car fetching logic 



useEffect(() => {
  fetchCars();
}, []);

const fetchCars = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/client/cars`);
    // Access the cars array in the response
    setCars(response.data.cars);
    console.log("cars", response.data.cars);
  } catch (error) {
    console.error("There was an error fetching the cars!", error);
    toast.error("Failed to load cars.");
  }
};


//handle auth when clicking on rent now 
// Handler for "Rent Now" button
const handleRentNow = (carId: string) => {
  console.log("Car ID for future use:", carId); // Placeholder for future logic

  if (isAuthenticated) {

    navigate(`/pages/booking-checkout/${carId}`);
    // Example of passing carId in state
  } else {
    // Redirect to /authentication/login if not authenticated
    navigate('/authentication/login', { state: { from: `/pages/booking-checkout/${carId}` } });
  }
};


useEffect(() => {
  if (isAuthenticated) {
    const fetchWishlistCars = async () => {
      try {
        const response = await axiosInstance.get('/api/wishlist');
        setWishlistCars(response.data);
        // Store wishlist car IDs for easy lookup
        setWishlist(response.data.map((car) => car._id));
      } catch (error) {
        console.error('Error fetching wishlist cars:', error);
      }
    };

    fetchWishlistCars();
  } else {
    // Clear wishlist data if not authenticated
    setWishlistCars([]);
    setWishlist([]);
  }
}, [isAuthenticated]);

const handleWishlistClick = async (carId) => {
  if (!isAuthenticated) {
    // Redirect to register page
    navigate('/authentication/register');
    return;
  }

  try {
    if (wishlist.includes(carId)) {
      // Remove from wishlist
      await axiosInstance.delete(`/api/wishlist/${carId}`);
      setWishlist((prevWishlist) => prevWishlist.filter((id) => id !== carId));
      toast.error('Removed from the WishList successfully!');


    } else {
      // Add to wishlist
      await axiosInstance.post(`/api/wishlist/${carId}`);
      setWishlist((prevWishlist) => [...prevWishlist, carId]);
      toast.success('Added to the WishList successfully!');


    }
  } catch (error) {
    console.error('Error updating wishlist:', error);
  }
};

  
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories!", error);
    }
  };


  
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);
   const [isSearchVisible, setSearchVisible] = useState(true);
    const toggleSearchVisibility = () => {
      setSearchVisible((prev) => !prev);
    };
  return (
    <>
    
    <Header />
      {/* Banner */}
      <Helmet>
        <title>{translations.home.helmet.title}</title>
        <meta name="description" content={translations.home.helmet.description} />
        <link rel="canonical" href="https://cardnd.com/" />
      </Helmet>
      {!isMobile && (
        <section className="banner-section banner-slider">
          <div className="container">
            <ToastContainer />
            <div className="home-banner">
              <div className="row align-items-center">
                {/* Left Column */}
                <div className="col-lg-6" data-aos="fade-down">
                  <p className="explore-text">
                    <span>
                      <i className="fa-solid fa-thumbs-up me-2"></i>
                    </span>
                    {translations.home.banner.exploreText}
                  </p>
                  <h1>
                    <span>{translations.home.banner.heading.line1}</span> <br />
                    {translations.home.banner.heading.line2}
                  </h1>
                  <p>
                    {translations.home.banner.description}
                  </p>
                  <div className="view-all">
                    <Link
                      to={routes.listingGrid}
                      className="btn btn-view d-inline-flex align-items-center"
                    >
                      {translations.home.banner.buttonViewAll}{" "}
                      <span>
                        <i className="feather icon-arrow-right ms-2" />
                      </span>
                    </Link>
                  </div>
                </div>
                {/* Right Column */}
                <div className="col-lg-6" data-aos="fade-down">
                  <div className="banner-imgs">
                    <ImageWithBasePath
                      src="assets/img/car-right.png"
                      className="img-fluid aos"
                      alt={translations.home.banner.imageAlt}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
       )}
      {/* /Banner */}
      {/* Search */}
      <div
        ref={searchBarRef}
        style={{
          position: isSticky ? "fixed" : "relative",
          top: isSticky ? 0 : "auto",
        marginTop:  window.innerWidth <= 768 ? 80 : 0, 

          left: 0,
          width: "100%",
          zIndex: window.innerWidth <= 768 ? 10 : 30,

          backgroundColor: "white",
          boxShadow: isSticky ? "0px 2px 5px rgba(0, 0, 0, 0.1)" : "none",
          transition: "box-shadow 0.3s ease",
          
        }}
      >
      {isSearchVisible && (
        <div
          ref={searchBarRef}
          style={{
            position: isSticky ? "fixed" : "relative",
            top: isSticky ? 0 : "auto",
            marginTop: window.innerWidth <= 768 ? 80 : 0,
            left: 0,
            width: "100%",
            zIndex: window.innerWidth <= 768 ? 10 : 30,
            backgroundColor: "white",
            boxShadow: isSticky ? "0px 2px 5px rgba(0, 0, 0, 0.1)" : "none",
            transition: "box-shadow 0.3s ease",
          }}
        >
          <SearchSection toggleSearchVisibility={toggleSearchVisibility} />
        </div>
      )}
      </div>
      {!isSearchVisible && (
          <button
            onClick={toggleSearchVisibility}
            style={{
              position: "fixed",
              bottom: "50%",
              right: 20,
              width: 50,
              height: 50,
              backgroundColor: "#C09465",
              border: "none",
              borderRadius: "50%",
              color: "white",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
              fontSize: "20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 50, // Ensure it stays above other content
            }}
          >
            🔍 {/* Search Icon */}
          </button>
        )}
   
<section className="section popular-services popular-explore">
  <div className="container">
    <div className="section-heading" data-aos="fade-down">
      <h2>{translations.home.banner.carCategories}</h2>
    </div>
    <div
      className="row yacht-category-lists"
      style={{
        display: isMobile ? "grid" : "flex", // Grille pour les petits écrans
        gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "none",
        gap: isMobile ? "20px" : "0", // Espacement entre les éléments sur mobile
        flexWrap: !isMobile ? "wrap" : "unset", // Flex-wrap pour grand écran
      }}
    >
      {categories.map((category) => (
        <div
          key={category.id}
          className="custom-col"
          style={{
            flex: isMobile ? "0 0 auto" : "0 0 20%", // Largeur dynamique selon l'écran
            textAlign: "center",
          }}
        >
          <div className="yacht-cat-grid">
            <div className="yatch-card-img">
              <Link to={`${routes.listingGrid}/${category.slug}`}>
                {category.image && (
                  <img
                    src={`${BASE_URL}/${category.image}`}
                    alt={category.name}
                    className="img-fluid"
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                    }}
                  />
                )}
              </Link>
            </div>
            <div
              className="card-content d-flex align-items-center justify-content-between"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "10px",
              }}
            >
              <div>
                <h4>
                  <Link to={`${routes.listingGrid}/${category.slug}`}>
                    {category.name}
                  </Link>
                </h4>
              </div>
              <Link to={routes.listingGrid} className="arrow-right">
                <i className="bx bx-right-arrow-alt" />
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* Popular Services */}
      <section className="section popular-services popular-explore">
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading" data-aos="fade-down">
          <h2>{translations.home.banner.cars}</h2>

          
          </div>
          {/* /Heading title */}
          {/* car logos  */}
          {/* <div className="row justify-content-center">
            <div className="col-lg-12" data-aos="fade-down">
              <div className="listing-tabs-group">
                <ul className="nav listing-buttons gap-3" data-bs-tabs="tabs">
                  <li>
                    <Link
                      className="active"
                      aria-current="true"
                      data-bs-toggle="tab"
                      to="#Carmazda"
                    >
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/car-icon-01.svg"
                          alt="Mazda"
                        />
                      </span>
                      Mercedes
                    </Link>
                  </li>
                  <li>
                    <Link data-bs-toggle="tab" to="#Caraudi">
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/car-icon-02.svg"
                          alt="Audi"
                        />
                      </span>
                      Audi
                    </Link>
                  </li>
                  <li>
                    <Link data-bs-toggle="tab" to="#Carhonda">
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/car-icon-03.svg"
                          alt="Honda"
                        />
                      </span>
                      Honda
                    </Link>
                  </li>
                  <li>
                    <Link data-bs-toggle="tab" to="#Cartoyota">
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/car-icon-04.svg"
                          alt="Toyota"
                        />
                      </span>
                      Toyota
                    </Link>
                  </li>
                  <li>
                    <Link data-bs-toggle="tab" to="#Caracura">
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/car-icon-05.svg"
                          alt="Acura"
                        />
                      </span>
                      Acura
                    </Link>
                  </li>
                  <li>
                    <Link data-bs-toggle="tab" to="#Cartesla">
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/car-icon-06.svg"
                          alt="Tesla"
                        />
                      </span>
                      Tesla
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
          {/* car logos  end  */}

          <div className="tab-content">
            <div className="tab-pane active" id="Carmazda">
              <div className="row">
                {/*  car card start */}
                {cars.length > 0 ? (  
                  
                cars.map((car) => (

                  <>
                    {/* col */}
                    
                    <div
                     key={car._id}
                      className="col-lg-4 col-md-6 col-12"
                      data-aos="fade-down"
                    >
                      <div className="listing-item">
                        <div className="listing-img">
                          {car.images && car.images.length > 0 ? (
                            <Link to={`${routes.listingDetails}/${car._id}`}>
                              <img
                                src={`${BASE_URL}/api/uploads/${car.images[0]}`} // Fetching the first image dynamically
                                className="img-fluid"
                                alt={car.name}
                              />
                            </Link>
                          ) : (
                            <div>No Image Available</div>
                          )}
                         <div className="fav-item justify-content-end">
                            <button
                              className={`fav-icon ${wishlist.includes(car._id) ? 'selected' : ''}`}
                              onClick={() => handleWishlistClick(car._id)}
                            >
                              <i className="feather icon-heart" />
                            </button>
                          </div>
                          <span className="featured-text">
                            {car.name}
                          </span>
                        </div>

                        <div className="listing-content">
                          <div className="listing-features d-flex align-items-end justify-content-between">
                            <div className="list-rating">
                             
                              <h3 className="listing-title">
                                <Link to={routes.listingDetails}>
                                {car.name}

                                </Link>
                              </h3>
                              {/*  */}
                              <div className="list-rating">
                                {Array.from({ length: 5 }, (_, index) => {
                                  // const ratingValue = index + 1;
                                  const difference = car.averageRating - index;

                                  let starClass = 'far fa-star'; // Empty star

                                  if (difference >= 1) {
                                    // Full star
                                    starClass = 'fas fa-star filled';
                                  } else if (difference >= 0.5) {
                                    // Half star
                                    starClass = 'fas fa-star-half-alt filled';
                                  }

                                  return <i key={index} className={starClass} />;
                                })}
                                <span>
                                  ({car.averageRating}) {car.totalReviews} Reviews
                                </span>
                              </div>

                            </div>
                            <div className="list-km">
                              <span className="km-count">
                                <ImageWithBasePath
                                  src="assets/img/icons/map-pin.svg"
                                  alt="author"
                                />
                                3.5m
                              </span>
                            </div>
                          </div>
                          <div className="listing-details-group">
                            <ul>
                              <li>
                                <span>
                                  <ImageWithBasePath
                                    src="assets/img/icons/car-parts-05.svg"
                                    alt="Manual"
                                  />
                                </span>
                                <p>{car.transmission}</p>
                              </li>
                              <li>
                                <span>
                                  <ImageWithBasePath
                                    src="assets/img/icons/car-parts-02.svg"
                                    alt="10 KM"
                                  />
                                </span>
                                <p>{car.mileage} KM</p>
                              </li>
                              <li>
                                <span>
                                  <ImageWithBasePath
                                    src="assets/img/icons/car-parts-03.svg"
                                    alt="Petrol"
                                  />
                                </span>
                                <p>{car.fuelType}</p>
                              </li>
                            </ul>
                            <ul>
                              <li>
                                <span>
                                  <ImageWithBasePath
                                    src="assets/img/icons/car-parts-04.svg"
                                    alt="Power"
                                  />
                                </span>
                                <p>Power</p>
                              </li>
                              <li>
                                <span>
                                  <ImageWithBasePath
                                    src="assets/img/icons/car-parts-05.svg"
                                    alt={car.registrationYear}
                                  />
                                </span>
                                <p>{car.registrationYear}</p>
                              </li>
                              <li>
                                <span>
                                  <ImageWithBasePath
                                    src="assets/img/icons/car-parts-06.svg"
                                    alt="Persons"
                                  />
                                </span>
                                <p>{car.seats}Persons</p>
                              </li>
                            </ul>
                          </div>
                          <div className="listing-location-details">
                            <div className="listing-price">
                              <span>
                                <i className="feather icon-map-pin" />
                              </span>
                              {car.city}

                            </div>
                            <div className="listing-price">
                              <h6>
                              MAD {car.pricePerDay}  <span>/ Day</span>
                              </h6>
                            </div>
                          </div>
                          <div className="mt-3">
                            <div className="listing-button">
                              <button
                                className="btn btn-order w-100"
                                
                                onClick={() => handleRentNow(car._id)}
                              >
                                <i className="feather icon-calendar me-2" ></i>
                                Rent Now
                              </button>
                            </div>
                          </div>
                          
                           {/* <div className="listing-button">
                            <Link
                              to={routes.listingDetails}
                              className="btn btn-order"
                            >
                              <span>
                                <i className="feather icon-calendar me-2" />
                              </span>
                              Rent Now
                            </Link>
                 
                          </div>  */}
                         
                        </div>
                      </div>
                    </div>
                    {/* /col */}
                  </>
                      ))
                    ) : (
                      <div className="no-results">
                        <p>No cars available for the selected criteria.</p>
                        <p>Please adjust your search parameters.</p>
                      </div>
                    )}
   

                  {/* car card ends hhhheh */}
              </div>
            </div>
            {/* <div className="tab-pane fade" id="Caraudi">
              <div className="row">
                {/* col */}
                
                {/* col */}
                {/* <div className="col-lg-4 col-md-6 col-12" data-aos="fade-down">
                  <div className="listing-item">
                    <div className="listing-img">
                      <Link to={routes.listingDetails}>
                        <ImageWithBasePath
                          src="assets/img/cars/car-05.jpg"
                          className="img-fluid"
                          alt="Audi"
                        />
                      </Link>
                      <div
                        className="fav-item"
                        key={12}
                        onClick={() => handleItemClick(12)}
                      >
                        <span className="featured-text">Chevrolet</span>
                        <Link
                          to="#"
                          className={`fav-icon ${
                            selectedItems[12] ? "selected" : ""
                          }`}
                        >
                          <i className="feather icon-heart" />
                        </Link>
                      </div>
                    </div>
                    <div className="listing-content">
                      <div className="listing-features">
                        <Link to="#" className="author-img">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-05.jpg"
                            alt="author"
                          />
                        </Link>
                        <h3 className="listing-title">
                          <Link to={routes.listingDetails}>
                            2018 Chevrolet Camaro
                          </Link>
                        </h3>
                        <div className="list-rating">
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <span>(5.0)</span>
                        </div>
                      </div>
                      <div className="listing-details-group">
                        <ul>
                          <li>
                            <span>
                              <ImageWithBasePath
                                src="assets/img/icons/car-parts-05.svg"
                                alt="Manual"
                              />
                            </span>
                            <p>Manual</p>
                          </li>
                          <li>
                            <span>
                              <ImageWithBasePath
                                src="assets/img/icons/car-parts-02.svg"
                                alt="18 KM"
                              />
                            </span>
                            <p>18 KM</p>
                          </li>
                          <li>
                            <span>
                              <ImageWithBasePath
                                src="assets/img/icons/car-parts-03.svg"
                                alt="Diesel"
                              />
                            </span>
                            <p>Diesel</p>
                          </li>
                        </ul>
                        <ul>
                          <li>
                            <span>
                              <ImageWithBasePath
                                src="assets/img/icons/car-parts-04.svg"
                                alt="Power"
                              />
                            </span>
                            <p>Power</p>
                          </li>
                          <li>
                            <span>
                              <ImageWithBasePath
                                src="assets/img/icons/car-parts-05.svg"
                                alt=""
                              />
                            </span>
                            <p>2018</p>
                          </li>
                          <li>
                            <span>
                              <ImageWithBasePath
                                src="assets/img/icons/car-parts-06.svg"
                                alt="Persons"
                              />
                            </span>
                            <p>4 Persons</p>
                          </li>
                        </ul>
                      </div>
                      <div className="listing-location-details">
                        <div className="listing-price">
                          <span>
                            <i className="feather icon-map-pin" />
                          </span>
                          Germany
                        </div>
                        <div className="listing-price">
                          <h6>
                            $36 <span>/ Day</span>
                          </h6>
                        </div>
                      </div>
                      <div className="listing-button">
                        <Link
                          to={routes.listingDetails}
                          className="btn btn-order"
                        >
                          <span>
                            <i className="feather icon-calendar me-2" />
                          </span>
                          Rent Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* /col */}
                
                {/* /col */}
              {/* </div>
            </div>  */}
            <div className="tab-pane fade" id="Carhonda">
              <div className="row">
                {/* col */}
                <div className="col-lg-4 col-md-6 col-12" data-aos="fade-down">
                  <div className="listing-item">
                    <div className="listing-img">
                      <Link to={routes.listingDetails}>
                        <ImageWithBasePath
                          src="assets/img/cars/car-08.jpg"
                          className="img-fluid"
                          alt="Toyota"
                        />
                      </Link>
                      <div
                        className="fav-item"
                        key={19}
                        onClick={() => handleItemClick(19)}
                      >
                        <span className="featured-text">Toyota</span>
                        <Link
                          to="#"
                          className={`fav-icon ${
                            selectedItems[19] ? "selected" : ""
                          }`}
                        >
                          <i className="feather icon-heart" />
                        </Link>
                      </div>
                    </div>
                    <div className="listing-content">
                      <div className="listing-features">
                        <Link to="#" className="author-img">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-08.jpg"
                            alt="author"
                          />
                        </Link>
                        <h3 className="listing-title">
                          <Link to={routes.listingDetails}>
                            Toyota Tacoma 4WD
                          </Link>
                        </h3>
                        <div className="list-rating">
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <span>(5.0)</span>
                        </div>
                      </div>
                      <div className="listing-details-group">
                        <ul>
                          <li>
                            <span>
                              <ImageWithBasePath
                                src="assets/img/icons/car-parts-01.svg"
                                alt="Auto"
                              />
                            </span>
                            <p>Auto</p>
                          </li>
                          <li>
                            <span>
                              <ImageWithBasePath
                                src="assets/img/icons/car-parts-02.svg"
                                alt="22 miles"
                              />
                            </span>
                            <p>22 miles</p>
                          </li>
                          <li>
                            <span>
                              <ImageWithBasePath
                                src="assets/img/icons/car-parts-03.svg"
                                alt="Diesel"
                              />
                            </span>
                            <p>Diesel</p>
                          </li>
                        </ul>
                        <ul>
                          <li>
                            <span>
                              <ImageWithBasePath
                                src="assets/img/icons/car-parts-04.svg"
                                alt="Power"
                              />
                            </span>
                            <p>Power</p>
                          </li>
                          <li>
                            <span>
                              <ImageWithBasePath
                                src="assets/img/icons/car-parts-05.svg"
                                alt=""
                              />
                            </span>
                            <p>2019</p>
                          </li>
                          <li>
                            <span>
                              <ImageWithBasePath
                                src="assets/img/icons/car-parts-06.svg"
                                alt="Persons"
                              />
                            </span>
                            <p>5 Persons</p>
                          </li>
                        </ul>
                      </div>
                      <div className="listing-location-details">
                        <div className="listing-price">
                          <span>
                            <i className="feather icon-map-pin" />
                          </span>
                          Dallas, USA
                        </div>
                        <div className="listing-price">
                          <h6>
                            $30 <span>/ Day</span>
                          </h6>
                        </div>
                      </div>
                      <div className="listing-button">
                        <Link
                          to={routes.listingDetails}
                          className="btn btn-order"
                        >
                          <span>
                            <i className="feather icon-calendar me-2" />
                          </span>
                          Rent Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /col */}
                
                
                {/* /col */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Popular Services */}
      {/* Popular Cartypes */}
      {/* <section className="section popular-car-type">
        <div className="container"> */}
          {/* Heading title*/}
          {/* <div className="section-heading" data-aos="fade-down">
            <h2>Most Popular Cartypes</h2>
            <p>
            Most popular worldwide Car Category due to their reliability, affordability, and features.
            </p>
          </div> */}
          {/* /Heading title */}
          {/* <div className="row">
            <div className="popular-slider-group ">
              <div className="popular-cartype-slider">
              <Slider {...settings} className="service-slider">
                <div className="listing-owl-item">
                  <div className="listing-owl-group">
                    <div className="listing-owl-img">
                      <ImageWithBasePath
                        src="assets/img/cars/mp-vehicle-01.png"
                        className="img-fluid"
                        alt="Popular Cartypes"
                      />
                    </div>
                    <h6>Dacia</h6>
                    <p>35 Cars</p>
                  </div>
                </div>
                <div className="listing-owl-item">
                  <div className="listing-owl-group">
                    <div className="listing-owl-img">
                      <ImageWithBasePath
                        src="assets/img/cars/mp-vehicle-02.png"
                        className="img-fluid"
                        alt="Popular Cartypes"
                      />
                    </div>
                    <h6>BMW</h6>
                    <p>45 Cars</p>
                  </div>
                </div>
                <div className="listing-owl-item">
                  <div className="listing-owl-group">
                    <div className="listing-owl-img">
                      <ImageWithBasePath
                        src="assets/img/cars/mp-vehicle-03.png"
                        className="img-fluid"
                        alt="Popular Cartypes"
                      />
                    </div>
                    <h6>Range Rover</h6>
                    <p>15 Cars</p>
                  </div>
                </div>
                <div className="listing-owl-item">
                  <div className="listing-owl-group">
                    <div className="listing-owl-img">
                      <ImageWithBasePath
                        src="assets/img/cars/mp-vehicle-04.png"
                        className="img-fluid"
                        alt="Popular Cartypes"
                      />
                    </div>
                    <h6>Pickup</h6>
                    <p>17 Cars</p>
                  </div>
                </div>
               
                <div className="listing-owl-item">
                  <div className="listing-owl-group">
                    <div className="listing-owl-img">
                      <ImageWithBasePath
                        src="assets/img/cars/mp-vehicle-05.png"
                        className="img-fluid"
                        alt="Popular Cartypes"
                      />
                    </div>
                    <h6>Family MPV</h6>
                    <p>24 Cars</p>
                  </div>
                </div>
              </Slider>
              </div>
            </div>
          </div> */}
          {/* View More */}
          {/* <div className="view-all text-center" data-aos="fade-down">
            <Link
              to={routes.listingGrid}
              className="btn btn-view d-inline-flex align-items-center"
            >
              View all Cars{" "}
              <span>
                <i className="feather icon-arrow-right ms-2" />
              </span>
            </Link>
          </div>
          View More */}
        {/* </div>
      </section> */}
      {/* /Popular Cartypes */}
      {/* Facts By The Numbers */}
      <section className="section services bg-light-primary">
        <div className="service-right">
          <ImageWithBasePath
            src="assets/img/bg/service-right.svg"
            className="img-fluid"
            alt="services right"
          />
        </div>
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading" data-aos="fade-down">
            <h2>{translations.aboutUs.howItWorks.title}</h2>
            <p>

            </p>
          </div>
          {/* /Heading title */}
          <div className="services-work">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                <div className="services-group">
                  <div className="services-icon border-secondary">
                    <ImageWithBasePath
                      className="icon-img bg-secondary"
                      src="assets/img/icons/services-icon-01.svg"
                      alt="Choose Locations"
                    />
                  </div>
                  <div className="services-content">
                    <h3>{translations.aboutUs.howItWorks.steps[0].title}</h3>
                    <p>
                      {translations.aboutUs.howItWorks.steps[0].description}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                <div className="services-group">
                  <div className="services-icon border-warning">
                    <ImageWithBasePath
                      className="icon-img bg-warning"
                      src="assets/img/icons/services-icon-01.svg"
                      alt="Choose Locations"
                    />
                  </div>
                  <div className="services-content">
                    <h3>{translations.aboutUs.howItWorks.steps[1].title}</h3>
                    <p>
                      {translations.aboutUs.howItWorks.steps[1].description}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                <div className="services-group">
                  <div className="services-icon border-dark">
                    <ImageWithBasePath
                      className="icon-img bg-dark"
                      src="assets/img/icons/services-icon-01.svg"
                      alt="Choose Locations"
                    />
                  </div>
                  <div className="services-content">
                    <h3>{translations.aboutUs.howItWorks.steps[2].title} </h3>
                    <p>
                      {translations.aboutUs.howItWorks.steps[2].description}
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
      {/* /services */}

      <section className="section facts-number">
        <div className="facts-left">
          <ImageWithBasePath
            src="assets/img/bg/facts-left.png"
            className="img-fluid"
            alt="facts left"
          />
        </div>
        <div className="facts-right">
          <ImageWithBasePath
            src="assets/img/bg/facts-right.png"
            className="img-fluid"
            alt="facts right"
          />
        </div>
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading" data-aos="fade-down">
            <h2 className="title text-white">{translations.aboutUs.facts.title}</h2>
            <p className="description text-white">

            </p>
          </div>
          {/* /Heading title */}
          <div className="counter-group">
            <div className="row">
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-heart.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={16000}
                          duration={3}
                          separator=","
                        />
                        K<br />
                      </h4>
                      <p> {translations.aboutUs.facts.data[0].description}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-car.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={2547}
                          duration={3}
                          separator=","
                        />
                        +<br />
                      </h4>
                      <p>{translations.aboutUs.facts.data[1].description}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-headphone.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={625}
                          duration={3}
                          separator=","
                        />
                        K+
                        <br />
                      </h4>
                      <p>{translations.aboutUs.facts.data[2].description}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    <div className="count-img">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-history.svg"
                        alt=""
                      />
                    </div>
                    <div className="count-content">
                      <h4>
                        <CountUp
                          className="counterUp"
                          end={200}
                          duration={3}
                          separator=","
                        />
                        K+
                        <br />
                      </h4>
                      <p>{translations.aboutUs.facts.data[3].description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section why-choose">
        <div className="choose-left">
          <ImageWithBasePath
            src="assets/img/bg/choose-left.png"
            className="img-fluid"
            alt="Why Choose Us"
          />
        </div>
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading" data-aos="fade-down">
            <h2>{translations.aboutUs.whyChooseUs.title}</h2>

          </div>
          {/* /Heading title */}
          <div className="why-choose-group">
            <div className="row">
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-black">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-user-check.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>{translations.aboutUs.whyChooseUs.reasons[0].title}</h4>
                      <p>
                        {translations.aboutUs.whyChooseUs.reasons[0].description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-secondary">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-user-check.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>{translations.aboutUs.whyChooseUs.reasons[1].title}</h4>
                      <p>
                        {translations.aboutUs.whyChooseUs.reasons[1].description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-4 col-md-6 col-12 d-flex"
                data-aos="fade-down"
              >
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="choose-img choose-primary">
                      <ImageWithBasePath
                        src="assets/img/icons/bx-user-check.svg"
                        alt=""
                      />
                    </div>
                    <div className="choose-content">
                      <h4>{translations.aboutUs.whyChooseUs.reasons[2].title}</h4>
                      <p>
                        {translations.aboutUs.whyChooseUs.reasons[2].description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Why Choose Us */}
      {/* About us Testimonials */}
      {/* <section className="section about-testimonial testimonials-section">
        <div className="container"> */}
      {/* Heading title*/}
      {/* <div className="section-heading" data-aos="fade-down">
            <h2 className="title text-white">What People say about us? </h2>
            <p className="description text-white">
              Lorem Ipsum has been the industrys standard dummy text ever since
              the 1500s,
            </p>
          </div> */}
      {/* /Heading title */}
      {/* <div className="owl-carousel about-testimonials testimonial-group mb-0 owl-theme"> */}
      {/* /Carousel Item  */}
      {/* Carousel Item */}
      {/* <Slider {...settings}>
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="testimonial-item d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="quotes-head" />
                      <div className="review-box">
                        <div className="review-profile">
                          <div className="review-img">
                            <ImageWithBasePath
                              src={testimonial.image}
                              className="img-fluid"
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="review-details">
                          <h6>{testimonial.name}</h6>
                          <div className="list-rating">
                            <div className="list-rating-star">
                              {[...Array(Math.floor(testimonial.rating))].map(
                                (_, i) => (
                                  <i key={i} className="fas fa-star filled" />
                                )
                              )}
                            </div>
                            <p>
                              <span>({testimonial.rating})</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <p>{testimonial.review}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider> */}

      {/* /Carousel Item  */}
      {/* Carousel Item */}

      {/* /Carousel Item  */}
      {/* </div>
        </div>
      </section> */}
      {/* About us Testimonials */}
      <>
        {/* FAQ  */}
        <section className="section faq-section bg-light-primary">
          <div className="container">
            {/* Heading title*/}
            <div className="section-heading" data-aos="fade-down">
              <h2>{translations.aboutUs.faqs.title}</h2>
              <p>
                {translations.aboutUs.faqs.description}
              </p>
            </div>
            {/* /Heading title */}
            <div className="faq-info">
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqOne"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[0].question}

                  </Link>
                </h4>
                <div id="faqOne" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[0].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqTwo"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[1].question}

                  </Link>
                </h4>
                <div id="faqTwo" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[1].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqThree"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[2].question}

                  </Link>
                </h4>
                <div id="faqThree" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[2].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqFour"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[3].question}

                  </Link>
                </h4>
                <div id="faqFour" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[3].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqFive"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[4].question}

                  </Link>
                </h4>
                <div id="faqFive" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[4].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqSix"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[5].question}

                  </Link>
                </h4>
                <div id="faqSix" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[5].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqSeven"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[6].question}

                  </Link>
                </h4>
                <div id="faqSeven" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[6].answer}

                  </p>
                </div>
              </div>

              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqEight"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[7].question}

                  </Link>
                </h4>
                <div id="faqEight" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[7].answer}

                  </p>
                </div>
              </div>
              <div className="faq-card bg-white" data-aos="fade-down">
                <h4 className="faq-title">
                  <Link
                    className="collapsed"
                    data-bs-toggle="collapse"
                    to="#faqNine"
                    aria-expanded="false"
                  >
                    {translations.aboutUs.faqs.data[8].question}

                  </Link>
                </h4>
                <div id="faqNine" className="card-collapse collapse">
                  <p>
                    {translations.aboutUs.faqs.data[8].answer}

                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* /FAQ */}
<Footer/>

      </>
    </>
  );
};

export default HomeOne;
